import * as config from "../config";
const basePath = config.BASE_PATH;

const paths = {
  root: `${basePath}`,
  output: `${basePath}/output`,
  offtarget: `${basePath}/potential-offtarget`,
} as const;

export type Paths = (typeof paths)[keyof typeof paths];
export { paths };
